@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-dropdown'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="(control().errors && (control().dirty || control().touched)) || false">
    </form-label>
}
@if (!multiple()) {
    <p-select
        [inputId]="id() + '-dropdown'"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [options]="options()"
        [formControl]="control()"
        [showClear]="showClear()"
        [filter]="filter()"
        [filterBy]="filterBy() || optionLabel()"
        [editable]="editable()"
        [invalid]="control().errors && (control().dirty || control().touched)"
        [placeholder]="placeholder() | translate"
        [emptyMessage]="emptyMessage() | translate"
        [size]="size()"
        [fluid]="true"
        [appendTo]="appendTo()"
        (onChange)="onChange.emit($event.value)">
        <ng-template #item let-user>
            <div class="user-item">
                <p class="user-name">
                    {{ user.fullName }}
                </p>
                <p class="user-email">
                    {{ user.email }}
                </p>
            </div>
        </ng-template>
    </p-select>
} @else {
    <p-multiSelect
        [inputId]="id() + '-dropdown'"
        [display]="'chip'"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [appendTo]="appendTo()"
        [showClear]="showClear()"
        [maxSelectedLabels]="10"
        [placeholder]="placeholder() | translate"
        [size]="size()"
        [options]="options()"
        [fluid]="true"
        [filter]="filter()"
        [filterBy]="filterBy() || optionLabel()"
        [selectionLimit]="multiple() ? null : 1"
        [formControl]="control()">
        <ng-template #item let-user>
            <div class="user-item">
                <p class="user-name">
                    {{ user.fullName }}
                </p>
                <p class="user-email">
                    {{ user.email }}
                </p>
            </div>
        </ng-template>
    </p-multiSelect>
}

@if (control().invalid && (control().dirty || control().touched)) {
    @for (error of getErrorKeys(control().errors); track error) {
        <form-error [text]="getErrorMessage(error)"></form-error>
    }
}
